import { lazy } from 'react';
import { openModal } from '@/utils/modals';
import { VerificationRequiredModalDataProps } from './types';

const VerificationRequiredModal = lazy(() => import('./VerificationRequiredModal'));

export const openVerificationRequiredModal = (data: VerificationRequiredModalDataProps) =>
  openModal(VerificationRequiredModal, data);
